const map = {
	"./banner.svg": 56396,
	"./browsers/brave.svg": 92298,
	"./browsers/chrome.svg": 73698,
	"./browsers/edge.svg": 6371,
	"./browsers/firefox.svg": 94975,
	"./browsers/safari.svg": 22268,
	"./cards/amex.svg": 10295,
	"./cards/card.svg": 46564,
	"./cards/discover.svg": 14563,
	"./cards/jcb.svg": 7503,
	"./cards/master.svg": 33052,
	"./cards/meastro.svg": 53297,
	"./cards/unionpay.svg": 81403,
	"./cards/visa.svg": 52009,
	"./check-circle.svg": 13479,
	"./congrats.svg": 11889,
	"./create-item.svg": 24962,
	"./flash-success.svg": 62234,
	"./get-code-success.svg": 30930,
	"./loading.svg": 5214,
	"./power.svg": 92141,
	"./referral.svg": 45453,
	"./resubmit.svg": 54097,
	"./reward-sent.svg": 84598,
	"./settings.svg": 85145,
	"./success.svg": 94851,
	"./under-verification.svg": 20072
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89542;